<template>
  <v-card flat>
    <v-card-text>
      <v-form
        v-model="passwordSettingsForm"
        @keyup.native.enter="editPassword">
        <v-text-field
          :error-messages="errorMessages.old_password"
          v-model="settingsObj.old_password"
          :append-icon="showOldPassword ? 'visibility_off' : 'visibility'"
          :type="showOldPassword ? 'text' : 'password'"
          :rules="[$rules.isRequired, $rules.isValidPassword]"
          :label="$t('labelConfirm')"
          name="password-confirm-input"
          counter
          @click:append="showOldPassword = !showOldPassword"/>

        <password-pair
          :password="settingsObj.password"
          :password_confirmation="settingsObj.password_confirmation"
          :error-messages="errorMessages.password"
          @changed="val => settingsObj.password = val"
          @changedConfirm="val => settingsObj.password_confirmation = val"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading || !passwordSettingsForm"
        color="primary"
        @click="editPassword()">{{ $t('edit') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UserApi from '@/api/UserApi'
import PasswordPair from '@/components/global-components/inputs/PasswordPair.vue'

export default {
  name: 'PasswordSettings',
  components: { PasswordPair },
  props: [],
  data () {
    return {
      showOldPassword: false,
      isLoading: false,
      passwordSettingsForm: false,
      errorMessages: {},
      settingsObj: {
        old_password: '',
        password: '',
        password_confirmation: ''
      }
    }
  },
  methods: {
    async editPassword () {
      if (!this.passwordSettingsForm) return

      this.isLoading = true
      try {
        const result = await UserApi.updatePassword(this.settingsObj)
        this.$notification(result)
      } catch (e) {
        this.errorMessages = e.errors
      }
      this.isLoading = false
    }
  },
  watch: {
    settingsObj: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  i18n: {
    messages: {
      en: {
        edit: 'Save new password',
        labelConfirm: 'Confirm your old password'
      },
      tr: {
        edit: 'Yeni şifreyi kaydet',
        labelConfirm: 'Eski şifrenizi onaylayınız'
      },
      de: {
        edit: 'Speichern',
        labelConfirm: 'Bestätigen Sie bitte ihr altes Passwort'
      },
      ru: {
        edit: 'Сохранить новый пароль',
        labelConfirm: 'Подтвердите свой старый пароль'
      }
    }
  }
}
</script>
